/*
 * 原房间信息(渠道、入住类型)
 */
import React, { useMemo } from 'react';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { OccType } from '@/config/constant';
import { format2FullTimeStr } from '@/utils/date';
import { getOccType, getOccDuration } from '@/utils';
import {
  ExchangeRentRoomInfo,
  ExchangeRoomRole,
  RentTimeInfo,
  SourceChannelFullInfo,
} from '@/redux/reducers/reservation/base.d';
import { findItemByKey } from '@/redux/actions/reservation/helper';

import styles from './index.module.scss';

interface IProps {
  bizType: 'reserve' | 'checkIn';
  channelInfo: SourceChannelFullInfo;
  rentTimeInfo: RentTimeInfo;
  rentRoomInfos: ExchangeRentRoomInfo[];
}

const Index: React.FC<IProps> = (props) => {
  const { channelInfo, rentTimeInfo, bizType, rentRoomInfos } = props;
  // 入住类型
  const { rentOccType, isMultiType } = useMemo(() => {
    const occTypeMap = {};
    const originRoom = findItemByKey(rentRoomInfos, 'itemRole', ExchangeRoomRole.OriginRoom); // 原房间
    if (originRoom && originRoom.roomPriceList) {
      originRoom.roomPriceList.forEach((item) => {
        occTypeMap[item.occType] = true;
      });
    }
    const typeList = Object.keys(occTypeMap);
    return {
      rentOccType: typeList[0] as OccType,
      isMultiType: typeList.length > 1,
    };
  }, []);

  const isReserve = bizType === 'reserve';
  return (
    <ContentBlock title={intl.get('drawer_checkout_room_block_title')} className={styles.roomInfo}>
      <FormItem label={intl.get('app_reservation_channel_name')}>
        {channelInfo.channelName || '—'}
      </FormItem>
      <FormItem label={intl.get('app_reservation_strategy_name')}>
        {channelInfo.strategyName || '—'}
      </FormItem>
      <br />
      <FormItem label={intl.get('app_reservation_occ_type')}>
        {getOccType({
          type: rentOccType,
          multi: isMultiType,
        })}
      </FormItem>
      <FormItem
        label={intl.get(isReserve ? 'app_reservation_eta_time' : 'app_reservation_checkin_time')}
      >
        {format2FullTimeStr(rentTimeInfo.expectedArrivalTime)}
      </FormItem>
      <FormItem label={intl.get('app_reservation_etd_time')}>
        {format2FullTimeStr(rentTimeInfo.expectedDepartureTime)}
      </FormItem>
      <FormItem label={intl.get('app_reservation_occ_duration')}>
        {getOccDuration({
          type: rentOccType,
          duration: rentTimeInfo.rentTime,
          multi: isMultiType,
        })}
      </FormItem>
    </ContentBlock>
  );
};

export default Index;
